
<accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-users'></i> Información de Contacto / Encargado de Pago
      </span>
      <button [hidden]="disabled" type="button" class="btn btn-outline-primary mb-4" (click)="addContact()"><i class="fa fa-address-book"></i>&nbsp;Agregar Contacto</button>
      <pos-table [data]="contactTable" [pagination]="false" [headers]="getContactTableHeaders()" [disableHighlight]="true" highlightSuccessDangerField="status" ></pos-table>
      <div class="form-horizontal">
        <div class="row">
        </div>
        <div class="row col-12">
        </div>
    </div>
    </accordion-group>
    
</accordion>